module.exports = __webpack_public_path__ + "static/media/ardentarola3.24a8ca55.png";